import fbpixel from './fbpixel'
import gtag from './gtag'
import plau from './plausible'
import pin from './pinterest'
import hyr from './hyros'
import nbpixel from './nbpixel'
import ttpixel from './ttpixel'

interface PaymentData {
  value: number
  currency: string
}

interface PurchaseEventData extends PaymentData {
  email: string
  title: string
  description: string
}

const trackPageView = (url: string) => {
  gtag.trackPageView()
  fbpixel.trackPageView()
  pin.trackPageView()
  ttpixel.trackPageView()
}

const trackLead = (email: string) => {
  plau.trackEvent('Lead', 'Submit Email')
  fbpixel.trackEvent('Lead')
  ttpixel.trackEvent('CompleteRegistration', { email })
  pin.trackEvent('lead')
  nbpixel.trackEvent('submit_form')
  hyr.trackLead(email)
}

const trackInitiateCheckout = ({
  email,
  description,
  paymentData
}: {
  email: string
  description: string
  paymentData: PaymentData
}) => {
  plau.trackEvent('Initiate Checkout', description)
  fbpixel.trackEvent('InitiateCheckout')
  ttpixel.trackEvent('InitiateCheckout', { email, data: paymentData })
  nbpixel.trackEvent('initiate_checkout')
}

const trackPurchase = ({
  email,
  value,
  currency,
  title,
  description
}: PurchaseEventData) => {
  plau.trackEvent('Success Checkout', description)
  fbpixel.trackPurchase({
    currency,
    value
  })
  ttpixel.trackPurchase({
    email,
    currency,
    value
  })
  pin.trackPurchase({
    email,
    currency,
    value
  })
  hyr.trackPurchase({
    email,
    currency: 'USD',
    items: [
      {
        name: title,
        price: value
      }
    ]
  })
  nbpixel.trackEvent('complete_payment')
}

export {
  gtag,
  fbpixel,
  plau,
  pin,
  hyr,
  nbpixel,
  ttpixel,
  trackPageView,
  trackLead,
  trackInitiateCheckout,
  trackPurchase
}
